import type { PropsWithChildren } from 'react';

import cn from 'classnames';

import cls from './ProfileCard.module.css';

type ProfileCardProps = PropsWithChildren<{
    className?: string;
}>;

export const ProfileCard = ({ children, className }: ProfileCardProps) => (
    <section className={cn(cls.card, className)}>{children}</section>
);
